<template>
  <div class="wrapper">
    <div class="container outcome-content-container">
      <a class="back-button btn btn-default-back" :href="backButtonLink">
        {{ backButtonText }}
      </a>

      <transition name="fade" mode="out-in">
        <router-view
          :isTeamLeaderOrOrgAdmin="isTeamLeaderOrOrgAdmin"
          @update-stepper="updateStepper"
          @handle-complete-page="handleCompletePage"
          @hide-stepper="hideStepper"
        />
      </transition>
      <div v-if="displayStepper" class="stepper">
        <Stepper
          v-if="isTeamLeaderOrOrgAdmin && !isCompletePage && step !== undefined"
          :completed-step="computedStep"
          :steps-count="3"
          :show-tooltip="false"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import axios from "axios";
import { computed, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import Stepper from "../../components/team-outcomes/progress-stepper.vue";
import { csContext } from "../../services/cs-context";

const teamId = ref("");
const isTeamLeader = ref(false);
const isCompletePage = ref(false);
const step = ref(-1);
const displayStepper = ref(true);

const computedStep = computed(() => step.value);

function updateStepper(routeName: string): void {
  switch (routeName) {
    case "selectTeamOutcome":
      step.value = -1;
      break;
    case "selectTeamPathway":
      step.value = 0;
      break;
    case "viewPathway":
      step.value = 1;
      break;
    default:
      step.value = -1;
      break;
  }
}

const isTeamLeaderOrOrgAdmin = computed(
  () => isTeamLeader.value || csContext.userProfile.isOrgAdmin,
);

function handleCompletePage(value: boolean): void {
  isCompletePage.value = value;
}

function hideStepper(): void {
  displayStepper.value = false;
}

async function getTeamLeaderInfo(): Promise<void> {
  const response = await axios.get(`/api/teamuserpermissions/${teamId.value}`);
  isTeamLeader.value = response.data.isLeader;
}

const route = useRoute();

onBeforeMount(async () => {
  teamId.value = route.params.id as string;
  await getTeamLeaderInfo();
});

const backButtonLink = computed(() => {
  switch (route.name) {
    case "selectTeamPathway":
      return `/team/outcomes/${teamId.value}/select`;
    case "viewPathway":
      return `/team/outcomes/${teamId.value}/outcome/${route.params.outcomeUid}/select`;
    case "selectTeamOutcome":
    default:
      return `/home?view=TeamDashboard&teamId=${teamId.value}`;
  }
});

const backButtonText = computed(() => (route.name === "selectTeamOutcome" ? "My Team" : "Back"));
</script>
<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
@import "../../styles/outcomes/outcomes-view.less";
</style>
